import { CompRef } from '@wix/document-services-types';
import {
  WidgetSlot,
  WidgetSlotPosition,
  WidgetSlotToMoveContent,
  PluginsHostApiContext,
} from '@wix/editor-platform-host-integration-apis';

import { PlatformContext } from '../../../types/platformApi';
import { SitePluginsHostIntegrationApi } from './types';

export class SlotsService {
  hostAPI: SitePluginsHostIntegrationApi;

  constructor(hostAPI: SitePluginsHostIntegrationApi) {
    this.hostAPI = hostAPI;
  }

  public getSlotPlaceholderRefByContentRef(
    compRef: CompRef,
  ): CompRef | undefined {
    return this.hostAPI.getSlotPlaceholderRefByContentRef(compRef);
  }

  public getWidgetHostRefBySlotRef(compRef: CompRef): CompRef {
    return this.hostAPI.getWidgetHostRefBySlotRef(compRef);
  }

  public getWidgetHostRefByWidgetRef(compRef: CompRef): CompRef {
    return this.hostAPI.getWidgetHostRefByWidgetRef(compRef);
  }

  public getWidgetSlot(slotComponentRef: CompRef): WidgetSlot {
    return this.hostAPI.getWidgetSlot(slotComponentRef);
  }

  public getWidgetSlots(widgetCompRef: CompRef): WidgetSlot[] {
    return this.hostAPI.getWidgetSlots(widgetCompRef);
  }

  public getSlotPosition(compRef: CompRef): WidgetSlotPosition | null {
    return this.hostAPI.getSlotPosition(compRef);
  }

  public getCompRefForSlotSelection(compRef: CompRef): CompRef | undefined {
    return this.hostAPI.getCompRefForSlotSelection(compRef);
  }

  public getSlotInBlocksAppEditor(compRef: CompRef): WidgetSlot | undefined {
    return this.hostAPI.getSlotInBlocksAppEditor(compRef);
  }

  public getAvailableWidgetSlotsToMoveContent(
    compRef: CompRef,
  ): Pick<WidgetSlotToMoveContent, 'slotRef' | 'name'>[] {
    return this.hostAPI.getAvailableWidgetSlotsToMoveContent(compRef);
  }

  public getWidgetSlotsToMoveContent(
    compRef: CompRef,
  ): WidgetSlotToMoveContent[] {
    return this.hostAPI.getWidgetSlotsToMoveContent(compRef);
  }

  public hasWidgetSlot(slotComponentRef: CompRef): boolean {
    return this.hostAPI.hasWidgetSlot(slotComponentRef);
  }

  public async moveToSlot(
    context: PlatformContext,
    fromSlotComponentRef: CompRef,
    toSlotComponentRef: CompRef,
    pluginsHostAPIContext: PluginsHostApiContext,
  ): Promise<void> {
    return this.hostAPI.moveToSlot(
      context,
      fromSlotComponentRef,
      toSlotComponentRef,
      pluginsHostAPIContext,
    );
  }

  public async highlightSlot(slotComponentRef: CompRef): Promise<void> {
    return this.hostAPI.highlightSlot(slotComponentRef);
  }

  public unhighlightSlot(slotComponentRef: CompRef): void {
    return this.hostAPI.unhighlightSlot(slotComponentRef);
  }

  public isSlotContentMovable(compRef: CompRef): boolean {
    return this.hostAPI.isSlotContentMovable(compRef);
  }

  public isSlotContentPotentialMovable(compRef: CompRef): boolean {
    return this.hostAPI.isSlotContentPotentialMovable(compRef);
  }
}
